import { z } from "zod";
import { PostalAddressSchema } from "./PostalAddress";

export const FavoriteLocationSchema = z.object({
  name: z.string().nonempty(),
  postalAddress: PostalAddressSchema,
});

export type FavoriteLocation = z.infer<typeof FavoriteLocationSchema>;
